import { render } from "./all-course.vue?vue&type=template&id=af4c1ab2&scoped=true"
import script from "./all-course.vue?vue&type=script&lang=js"
export * from "./all-course.vue?vue&type=script&lang=js"

import "./all-course.vue?vue&type=style&index=0&id=af4c1ab2&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4c1ab2"]])

export default __exports__